"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _axios = _interopRequireDefault(require("axios"));

var _DashboardTimezoneDisclaimer = require("./DashboardTimezoneDisclaimer");

var _KeyInsightCard = require("./KeyInsightCard");

var _AnalyticsDateFormatter = _interopRequireDefault(require("./AnalyticsDateFormatter"));

var _utils = require("./utils");

var _DashboardDateRangeFilter = _interopRequireDefault(require("./DashboardDateRangeFilter"));

var _DashboardCategoryFilter = _interopRequireDefault(require("./DashboardCategoryFilter"));

var _QueryParameters = _interopRequireDefault(require("./QueryParameters"));

var _MetricsRow = _interopRequireDefault(require("./UtilityComponents/MetricsRow"));

var _ExternalLink = require("../ui-components/ExternalLink");

var _UserRolesFilter = _interopRequireDefault(require("./UtilityComponents/UserRolesFilter"));

var _service = require("@insided/deprecated-control/analytics/service");

var _userRolesService = require("@insided/control/services/userRolesService");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var defaultMetrics = {
  questionsAsked: 0,
  questionsAnswered: 0,
  percentQuestionsAnswered: 0,
  averageResponseTime: ''
};
var CommunityArticleLink = 'https://community.insided.com/dashboards-94/guide-to-the-enhanced-q-a-dashboard-5350';

var SuccessDashboard = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SuccessDashboard, _Component);

  var _super = _createSuper(SuccessDashboard);

  function SuccessDashboard(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SuccessDashboard);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "wrapperRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _roles$mainRoles, _roles$customRoles, _yield$Promise$all, _yield$Promise$all2, presetDateRanges, roles, defaultDateRange, _dateRangeForDisplay, dateFrom, dateTill, selectedDateRange, selectedPresetId, updatedState;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0, _utils.trackDashboardUsage)('q-and-a-dashboard');

              _this.setState({
                isKeyInsightLoading: true,
                isLoading: true
              });

              _context.prev = 2;
              _context.next = 5;
              return Promise.all([(0, _service.fetchDateRangeFilter)(), (0, _userRolesService.fetchUserRoles)()]);

            case 5:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 2);
              presetDateRanges = _yield$Promise$all2[0];
              roles = _yield$Promise$all2[1];
              defaultDateRange = (0, _utils.getDefaultDateRange)(presetDateRanges, _this.state.selectedPresetDateRangeId);
              _dateRangeForDisplay = (0, _utils.dateRangeForDisplay)(_this.state.storedState, defaultDateRange, _this.state.selectedPresetDateRangeId), dateFrom = _dateRangeForDisplay.dateFrom, dateTill = _dateRangeForDisplay.dateTill, selectedDateRange = _dateRangeForDisplay.selectedDateRange, selectedPresetId = _dateRangeForDisplay.selectedPresetId, updatedState = _dateRangeForDisplay.updatedState;

              _this.setState({
                isLoading: false,
                userRoles: {
                  mainRoles: (_roles$mainRoles = roles.mainRoles) !== null && _roles$mainRoles !== void 0 ? _roles$mainRoles : [],
                  customRoles: (_roles$customRoles = roles.customRoles) !== null && _roles$customRoles !== void 0 ? _roles$customRoles : []
                },
                presetDateRangeList: presetDateRanges,
                selectedPresetDateRangeId: selectedPresetId,
                selectedDate: selectedDateRange,
                startDate: dateFrom,
                endDate: dateTill,
                storedState: updatedState
              });

              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](2);

              _this.setState({
                isLoading: false
              });

            case 17:
              _this.fetchSuccessKeyInsights();

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 14]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addHandler", function () {
      var openedDropdownName = _this.state.openedDropdownName;

      if (openedDropdownName) {
        window.document.addEventListener('mousedown', _this.handleClickOutside);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeHandler", function () {
      window.document.removeEventListener('mousedown', _this.handleClickOutside);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function (e) {
      if (!_this.wrapperRef) return;

      if (!_this.wrapperRef.contains(e.target)) {
        _this.onResetDateRange();

        _this.setState({
          openedDropdownName: ''
        }, _this.removeHandler);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchSuccessKeyInsights", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var res, _res$data, all, filtered;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                isKeyInsightLoading: true
              });

              _context2.prev = 1;
              _context2.next = 4;
              return _this.fetchData('/analyticsV2/successKeyInsights');

            case 4:
              res = _context2.sent;
              _res$data = res.data, all = _res$data.all, filtered = _res$data.filtered;

              _this.setState({
                allMetrics: all,
                filteredMetrics: filtered,
                isKeyInsightLoading: false
              });

              _context2.next = 12;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](1);

              _this.setState({
                isKeyInsightLoading: false
              });

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 9]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchData", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(url) {
        var _this$state, startDate, endDate, selectedCategories, selectedAnswerRoles, selectedQuestionRoles, answerUserRoles, questionUserRoles, filterOptions;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$state = _this.state, startDate = _this$state.startDate, endDate = _this$state.endDate, selectedCategories = _this$state.selectedCategories, selectedAnswerRoles = _this$state.selectedAnswerRoles, selectedQuestionRoles = _this$state.selectedQuestionRoles;
                answerUserRoles = {
                  mainRoles: {
                    rolesList: selectedAnswerRoles.mainRoles.rolesList.map(function (x) {
                      return parseInt(x);
                    }),
                    condition: selectedAnswerRoles.mainRoles.condition
                  },
                  customRoles: {
                    rolesList: selectedAnswerRoles.customRoles.rolesList.map(function (x) {
                      return parseInt(x);
                    }),
                    condition: selectedAnswerRoles.customRoles.condition
                  }
                };
                questionUserRoles = {
                  mainRoles: {
                    rolesList: selectedQuestionRoles.mainRoles.rolesList.map(function (x) {
                      return parseInt(x);
                    }),
                    condition: selectedQuestionRoles.mainRoles.condition
                  },
                  customRoles: {
                    rolesList: selectedQuestionRoles.customRoles.rolesList.map(function (x) {
                      return parseInt(x);
                    }),
                    condition: selectedQuestionRoles.customRoles.condition
                  }
                };
                filterOptions = {
                  start: _AnalyticsDateFormatter.default.formatDate(startDate),
                  end: _AnalyticsDateFormatter.default.formatDate(endDate, false),
                  answerUserRoles: answerUserRoles,
                  questionUserRoles: questionUserRoles,
                  categories: selectedCategories
                };
                _context3.next = 6;
                return _axios.default.post(url, {
                  filters: filterOptions
                });

              case 6:
                return _context3.abrupt("return", _context3.sent);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleUserRoleQuestionDropdown", function (value) {
      _this.setState({
        openedDropdownName: value ? 'questionUserRole' : ''
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleUserRoleAnswerDropdown", function (value) {
      _this.setState({
        openedDropdownName: value ? 'answerUserRole' : ''
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUserRolesChanged", function (filterId, filterType, data) {
      var _this$state2 = _this.state,
          selectedQuestionRoles = _this$state2.selectedQuestionRoles,
          selectedAnswerRoles = _this$state2.selectedAnswerRoles;
      var queryParams = new _QueryParameters.default();
      var rolesList = data.data.map(function (d) {
        return d.id.toString();
      });

      if (filterId === 'questionUserRole' && (filterType === 'mainRoles' || filterType === 'customRoles')) {
        _this.setState({
          openedDropdownName: '',
          selectedQuestionRoles: _objectSpread(_objectSpread({}, selectedQuestionRoles), {}, (0, _defineProperty2.default)({}, filterType, {
            rolesList: rolesList,
            condition: data.condition
          }))
        });

        var paramKey = filterType === 'mainRoles' ? 'q_m' : 'q_c';
        queryParams.set("".concat(paramKey, "_list"), rolesList.join(',')).set("".concat(paramKey, "_type"), data.condition);
      } else if (filterId === 'answerUserRole' && (filterType === 'mainRoles' || filterType === 'customRoles')) {
        _this.setState({
          openedDropdownName: '',
          selectedAnswerRoles: _objectSpread(_objectSpread({}, selectedAnswerRoles), {}, (0, _defineProperty2.default)({}, filterType, {
            rolesList: rolesList,
            condition: data.condition
          }))
        });

        var _paramKey = filterType === 'mainRoles' ? 'a_m' : 'a_c';

        queryParams.set("".concat(_paramKey, "_list"), rolesList.join(',')).set("".concat(_paramKey, "_type"), data.condition);
      }

      window.history.pushState(null, 'roles changed', queryParams.getQueryString());

      _this.fetchSuccessKeyInsights();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetUserRoles", function () {
      _this.setState({
        openedDropdownName: ''
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearQuestionUserRoles", function (e) {
      _this.onClearUserRoles(e, 'questionUserRole');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearAnswerUserRoles", function (e) {
      _this.onClearUserRoles(e, 'answerUserRole');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearUserRoles", function (e, filterId) {
      e.preventDefault();
      e.stopPropagation();
      var queryParams = new _QueryParameters.default();

      if (filterId === 'questionUserRole') {
        _this.setState({
          openedDropdownName: '',
          selectedQuestionRoles: {
            mainRoles: {
              condition: '',
              rolesList: []
            },
            customRoles: {
              condition: '',
              rolesList: []
            }
          }
        });

        queryParams.unset('q_m_list').unset('q_m_type').unset('q_c_list').unset('q_c_type');
      } else if (filterId === 'answerUserRole') {
        _this.setState({
          openedDropdownName: '',
          selectedAnswerRoles: {
            mainRoles: {
              condition: '',
              rolesList: []
            },
            customRoles: {
              condition: '',
              rolesList: []
            }
          }
        });

        queryParams.unset('a_m_list').unset('a_m_type').unset('a_c_list').unset('a_c_type');
      }

      window.history.pushState(null, 'roles cleared', queryParams.getQueryString());

      _this.fetchSuccessKeyInsights();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleDateRange", function (value) {
      _this.setState({
        openedDropdownName: value ? 'dateRange' : ''
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPresetDateRangeChanged", function (selectedDate) {
      _this.setState({
        selectedPresetDateRangeId: selectedDate.id,
        selectedDate: selectedDate
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCustomDateRangeChanged", function (dates) {
      var customSelectedDate = {
        id: 'custom_range',
        label: 'Custom Range',
        startDate: dates[0],
        endDate: dates[1]
      };

      _this.setState({
        selectedDate: customSelectedDate,
        selectedPresetDateRangeId: customSelectedDate.id
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDateRangeChanged", function () {
      var _this$state3 = _this.state,
          selectedDate = _this$state3.selectedDate,
          selectedPresetDateRangeId = _this$state3.selectedPresetDateRangeId;

      _this.setState(function (prevState) {
        return {
          openedDropdownName: '',
          startDate: new Date(selectedDate.startDate),
          endDate: new Date(selectedDate.endDate),
          storedState: _objectSpread(_objectSpread({}, prevState.storedState), {}, {
            presetDateRangeId: selectedPresetDateRangeId,
            selectedDateRange: selectedDate
          })
        };
      });

      var queryString = new _QueryParameters.default();
      queryString.set('date_range', selectedPresetDateRangeId);

      if (selectedPresetDateRangeId !== 'custom_range') {
        queryString.unset('date_from').unset('date_till');
      } else {
        queryString.set('date_from', _AnalyticsDateFormatter.default.formatDateForUrl(selectedDate.startDate)).set('date_till', _AnalyticsDateFormatter.default.formatDateForUrl(selectedDate.endDate));
      }

      window.history.pushState(null, 'date range changed', queryString.getQueryString());
      (0, _utils.updateDateRangeInSessionStorage)(selectedDate);

      _this.fetchSuccessKeyInsights();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetDateRange", function () {
      var _this$state$storedSta = _this.state.storedState,
          presetDateRangeId = _this$state$storedSta.presetDateRangeId,
          selectedDateRange = _this$state$storedSta.selectedDateRange;

      _this.setState({
        openedDropdownName: '',
        selectedPresetDateRangeId: presetDateRangeId,
        selectedDate: selectedDateRange
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleCategoryDropdown", function (value) {
      var openedDropdownName = _this.state.openedDropdownName;

      if (openedDropdownName === 'dateRange') {
        _this.onResetDateRange();
      }

      _this.setState({
        openedDropdownName: value ? 'category' : ''
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCategoriesChanged", function (data) {
      _this.setState({
        selectedCategories: data,
        openedDropdownName: ''
      });

      window.history.pushState(null, 'categories changed', new _QueryParameters.default().set('categories', data.join(',')).getQueryString());

      _this.fetchSuccessKeyInsights();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetCategories", function () {
      _this.setState({
        openedDropdownName: ''
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearCategories", function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        selectedCategories: [],
        openedDropdownName: ''
      });

      window.history.pushState(null, 'categories cleared', new _QueryParameters.default().unset('categories').getQueryString());

      _this.fetchSuccessKeyInsights();
    });

    var _getStartAndEndDate = (0, _utils.getStartAndEndDate)(),
        initialStartDate = _getStartAndEndDate.initialStartDate,
        initialEndDate = _getStartAndEndDate.initialEndDate,
        initalDateRangeId = _getStartAndEndDate.initalDateRangeId;

    var _queryParams = new _QueryParameters.default();

    _this.setState({
      allMetrics: _objectSpread({}, defaultMetrics),
      filteredMetrics: _objectSpread({}, defaultMetrics),
      userRoles: {
        mainRoles: [],
        customRoles: []
      },
      selectedAnswerRoles: (0, _utils.getRoleFilterParamFromQuery)('a'),
      selectedQuestionRoles: (0, _utils.getRoleFilterParamFromQuery)('q'),
      selectedPresetDateRangeId: _queryParams.has('date_range') ? _queryParams.get('date_range') : initalDateRangeId,
      storedState: {
        presetDateRangeId: _queryParams.has('date_range') ? _queryParams.get('date_range') : initalDateRangeId,
        selectedDateRange: (0, _utils.getDefaultSelectedDate)()
      },
      openedDropdownName: '',
      startDate: _queryParams.has('date_from') ? (0, _utils.getDateWithDefaultTime)(_queryParams.get('date_from')) : initialStartDate,
      endDate: _queryParams.has('date_till') ? (0, _utils.getDateWithDefaultTime)(_queryParams.get('date_till')) : initialEndDate,
      presetDateRangeList: [],
      isLoading: false,
      isKeyInsightLoading: false,
      selectedCategories: _queryParams.has('categories') ? _queryParams.get('categories').split(',') : []
    });

    _this.toggleUserRoleQuestionDropdown = _this.toggleUserRoleQuestionDropdown.bind((0, _assertThisInitialized2.default)(_this));
    _this.toggleUserRoleAnswerDropdown = _this.toggleUserRoleAnswerDropdown.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetUserRoles = _this.onResetUserRoles.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClearUserRoles = _this.onClearUserRoles.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClearAnswerUserRoles = _this.onClearAnswerUserRoles.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClearQuestionUserRoles = _this.onClearQuestionUserRoles.bind((0, _assertThisInitialized2.default)(_this));
    _this.toggleDateRange = _this.toggleDateRange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onDateRangeChanged = _this.onDateRangeChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetDateRange = _this.onResetDateRange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onPresetDateRangeChanged = _this.onPresetDateRangeChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCustomDateRangeChanged = _this.onCustomDateRangeChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onUserRolesChanged = _this.onUserRolesChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.toggleCategoryDropdown = _this.toggleCategoryDropdown.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetCategories = _this.onResetCategories.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCategoriesChanged = _this.onCategoriesChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClearCategories = _this.onClearCategories.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SuccessDashboard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var categoriesV2 = this.props.categoriesV2;
      var _this$state4 = this.state,
          isKeyInsightLoading = _this$state4.isKeyInsightLoading,
          allMetrics = _this$state4.allMetrics,
          filteredMetrics = _this$state4.filteredMetrics,
          presetDateRangeList = _this$state4.presetDateRangeList,
          userRoles = _this$state4.userRoles,
          selectedAnswerRoles = _this$state4.selectedAnswerRoles,
          selectedQuestionRoles = _this$state4.selectedQuestionRoles,
          openedDropdownName = _this$state4.openedDropdownName,
          selectedPresetDateRangeId = _this$state4.selectedPresetDateRangeId,
          startDate = _this$state4.startDate,
          endDate = _this$state4.endDate,
          isLoading = _this$state4.isLoading,
          selectedDate = _this$state4.selectedDate,
          selectedCategories = _this$state4.selectedCategories;
      return (0, _preact.h)("div", {
        className: "success-dashboard-overview dashboard-overview",
        "data-bounded-context": "Analytics",
        "data-entity": "q-and-a-dashboard"
      }, (0, _preact.h)(_header.default, {
        title: "Q&A Dashboard",
        disableCancelButton: true,
        disableSaveButton: true
      }), (0, _preact.h)("div", {
        className: "filter-container",
        ref: function ref(node) {
          _this2.wrapperRef = node;
        }
      }, (0, _preact.h)(_DashboardDateRangeFilter.default, {
        isLoading: isLoading,
        startDate: startDate,
        endDate: endDate,
        isDropdownOpen: openedDropdownName === 'dateRange',
        items: presetDateRangeList,
        selectedDate: selectedDate,
        selectedPresetId: selectedPresetDateRangeId,
        toggleDropdown: this.toggleDateRange,
        onChange: this.onDateRangeChanged,
        onReset: this.onResetDateRange,
        onCustomDateChange: this.onCustomDateRangeChanged,
        onPresetDateChange: this.onPresetDateRangeChanged,
        showMonths: 2,
        "data-element-name": "Date range filter",
        "data-track-type": "click"
      }), (0, _preact.h)(_DashboardCategoryFilter.default, {
        isLoading: isLoading,
        id: "categories",
        name: "(parent) category or group",
        customClassName: "categories",
        title: "Published in",
        isDropdownOpen: openedDropdownName === 'category',
        toggleDropdown: this.toggleCategoryDropdown,
        resetDropdown: this.onResetCategories,
        onClear: this.onClearCategories,
        onChange: this.onCategoriesChanged,
        categoriesV2: categoriesV2,
        selectedItems: selectedCategories
      }), (0, _preact.h)(_UserRolesFilter.default, {
        isLoading: isLoading,
        filterId: "questionUserRole",
        name: "user role question",
        customClassName: "user-role",
        title: "User role question",
        isDropdownOpen: openedDropdownName === 'questionUserRole',
        toggleDropdown: this.toggleUserRoleQuestionDropdown,
        resetDropdown: this.onResetUserRoles,
        onClear: this.onClearQuestionUserRoles,
        onChange: this.onUserRolesChanged,
        userRoles: userRoles,
        selectedItems: selectedQuestionRoles,
        dataElementName: "User role question filter",
        dataTrackType: "click"
      }), (0, _preact.h)(_UserRolesFilter.default, {
        isLoading: isLoading,
        filterId: "answerUserRole",
        name: "user role answer",
        customClassName: "user-role",
        title: "User role answer",
        isDropdownOpen: openedDropdownName === 'answerUserRole',
        toggleDropdown: this.toggleUserRoleAnswerDropdown,
        resetDropdown: this.onResetUserRoles,
        onClear: this.onClearAnswerUserRoles,
        onChange: this.onUserRolesChanged,
        userRoles: userRoles,
        selectedItems: selectedAnswerRoles,
        dataElementName: "User role answer filter",
        dataTrackType: "click"
      })), (0, _preact.h)("div", {
        className: "metric-container"
      }, (0, _preact.h)(_MetricsRow.default, {
        title: "Questions asked",
        isLoading: isKeyInsightLoading,
        titleTooltipTexts: ['The number of questions asked in the selected time period.', 'The time filter applies to the question creation time.']
      }, (0, _preact.h)("div", {
        className: "metrics-row-cards"
      }, (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "All",
        total: allMetrics.questionsAsked,
        hideComparisionWithPreviousPeriod: true,
        isLoading: false,
        titleTooltip: "The user role filters do not apply."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Based on filtered role",
        total: filteredMetrics.questionsAsked,
        hideComparisionWithPreviousPeriod: true,
        isLoading: false,
        titleTooltip: "The user role filters apply only to the author of the question."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        isPercentage: true,
        title: "% Based on filtered role",
        total: allMetrics.questionsAsked === 0 ? 0 : filteredMetrics.questionsAsked / allMetrics.questionsAsked * 100,
        hideComparisionWithPreviousPeriod: true,
        isLoading: false,
        titleTooltip: "Formula: Questions asked Based on Filtered Role / All Questions asked *100"
      }))), (0, _preact.h)(_MetricsRow.default, {
        title: "Questions answered",
        isLoading: isKeyInsightLoading,
        titleTooltipTexts: ['The number of questions asked in the selected time period that also have an answer marked (whenever answers were given).', 'The time filter applies to the question creation time.']
      }, (0, _preact.h)("div", {
        className: "metrics-row-cards"
      }, (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "All",
        total: allMetrics.questionsAnswered,
        hideComparisionWithPreviousPeriod: true,
        isLoading: false,
        titleTooltip: "The user role filters do not apply."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Based on filtered role",
        total: filteredMetrics.questionsAnswered,
        hideComparisionWithPreviousPeriod: true,
        isLoading: false,
        titleTooltip: "The user role filters apply to the author of the question and the author of the best answer."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        isPercentage: true,
        title: "% Based on filtered role",
        total: allMetrics.questionsAnswered === 0 ? 0 : filteredMetrics.questionsAnswered / allMetrics.questionsAnswered * 100,
        hideComparisionWithPreviousPeriod: true,
        isLoading: false,
        titleTooltip: "Formula: Questions answered Based on Filtered Role / All Questions answered  *100"
      }))), (0, _preact.h)(_MetricsRow.default, {
        title: "% Questions answered",
        isLoading: isKeyInsightLoading,
        titleTooltipTexts: ['The % of questions created in the selected time period which have an answer marked (whenever the answer was given).', 'The time filter applies to the question creation time.']
      }, (0, _preact.h)("div", {
        className: "metrics-row-cards"
      }, (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "All",
        total: allMetrics.percentQuestionsAnswered,
        hideComparisionWithPreviousPeriod: true,
        isPercentage: true,
        isLoading: false,
        titleTooltip: "Formula: All Questions answered/ All Questions asked*100"
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Based on filtered role",
        total: filteredMetrics.percentQuestionsAnswered,
        hideComparisionWithPreviousPeriod: true,
        isPercentage: true,
        isLoading: false,
        titleTooltip: "Formula: Questions answered Based on Filtered Role/ Questions asked Based on Filtered Role *100"
      }))), (0, _preact.h)(_MetricsRow.default, {
        title: "Answers",
        isLoading: isKeyInsightLoading,
        titleTooltipTexts: ['The number of answers given in the selected time period whenever the questions were asked.', 'The time filter applies to the answer creation time, not the time when it was marked as the best answer.']
      }, (0, _preact.h)("div", {
        className: "metrics-row-cards"
      }, (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "All",
        total: allMetrics.answers,
        hideComparisionWithPreviousPeriod: true,
        isLoading: false,
        titleTooltip: "The user role filters do not apply."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Based on filtered role",
        total: filteredMetrics.answers,
        hideComparisionWithPreviousPeriod: true,
        isLoading: false,
        titleTooltip: "The user role filters apply only to the author of the answer. Time filter applies only to the answers not to the questions."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        isPercentage: true,
        title: "% Based on filtered role",
        total: allMetrics.answers && filteredMetrics.answers ? filteredMetrics.answers / allMetrics.answers * 100 : 0,
        hideComparisionWithPreviousPeriod: true,
        isLoading: false,
        titleTooltip: "Formula: Answers Based on filtered role /All Answers * 100"
      }))), (0, _preact.h)(_MetricsRow.default, {
        title: "Avg. answer time",
        isLoading: isKeyInsightLoading,
        titleTooltipTexts: ['The average amount of time between the creation of a question and the creation of the answer whenever it was marked as best answer.', 'The time filter applies to the question creation time.']
      }, (0, _preact.h)("div", {
        className: "metrics-row-cards"
      }, (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "All",
        total: allMetrics.averageResponseTime,
        hideComparisionWithPreviousPeriod: true,
        isLoading: false,
        titleTooltip: "The user role filters do not apply."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Based on filtered role",
        total: filteredMetrics.averageResponseTime,
        hideComparisionWithPreviousPeriod: true,
        isLoading: false,
        titleTooltip: "The user role filters apply to the author of the question and the author of the best answer."
      })))), (0, _preact.h)(_DashboardTimezoneDisclaimer.DashboardTimezoneDisclaimer, null), (0, _preact.h)(_ExternalLink.ExternalLink, {
        label: "Learn more about these metrics in our Knowledge Base",
        url: CommunityArticleLink,
        isExternalLinkForToggle: false
      }));
    }
  }]);
  return SuccessDashboard;
}(_preact.Component);

var _default = SuccessDashboard;
exports.default = _default;